import React, { useState } from "react";
import { Col } from "reactstrap";
import { Icon } from "../../../components/Component";

const TextInput = ({
  disabled,
  label,
  required,
  id_val,
  name,
  handleChange,
  error_stat,
  err_Msg,
  onFocus,
  colSize,
  type,
  maxlength,
  minlength,
  max,
  value,
  min,
  onBlur,
  parentClassName,
  onKeyDown,
  placeholder,
  helper,
}) => {
  const [showPassword, setShowPassword] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };

  return (
    <Col lg={colSize ? colSize : "6"} className={parentClassName}>
      <div className="form-group">
        {label && (
          <div className="form-label-group">
            <label className="form-label" htmlFor={id_val}>
              {label} {required && <span className="text-danger pr-2"> *</span>}
            </label>
            <span>{helper}</span>
          </div>
        )}
        {!label && helper && (
          <div className="form-label-group">
            <span>{helper}</span>
          </div>
        )}
        <div className="form-control-wrap" style={{ position: "relative" }}>
          <input
            onKeyDown={onKeyDown}
            required={required}
            onChange={handleChange}
            type={type === "password" ? (showPassword ? "text" : "password") : type}
            id={id_val}
            max={type === "date" || type === "number" ? max : ""}
            className="form-control"
            name={name}
            min={type === "date" || type === "number" ? min : ""}
            value={value}
            maxLength={maxlength || ""}
            minLength={minlength || ""}
            disabled={disabled}
            onFocus={onFocus}
            onBlur={onBlur}
            placeholder={placeholder}
          />
          {type === "password" && (
            <Icon
              name={showPassword ? "eye-off" : "eye"}
              onClick={togglePasswordVisibility}
              style={{
                position: "absolute",
                right: "10px",
                top: "50%",
                transform: "translateY(-50%)",
                cursor: "pointer",
              }}
            />
          )}
        </div>
        <span className="text-danger">{error_stat ? `${err_Msg} ` : ""}</span>
      </div>
    </Col>
  );
};

export default TextInput;
